<div class="jhi-file-upload-wrapper">
	<input
		type="file"
		class="form-control"
		#fileUpload
		(change)="onFileChange($event)"
		[accept]="acceptedFileTypes"
		[hidden]="true"
		[multiple]="multiple"
		[disabled]="disabled">

	<div class="file-row" title="{{hasFile() ? fileName : (noFileLabel | translate)}}">
		<button class="choose-file-btn"
			type="button"
			[ngClass]="buttonClass"
			(click)="openFileDialog()"
			[disabled]="disabled">
			{{ buttonLabel | translate }}
		</button>

		<span class="ms-2 file-name-container" *ngIf="showFileName">

			@if (hasFile()) {
				<span class="file-name">{{ fileNamePart }}</span>
				<span class="file-ext">{{ fileNameExt }}</span>
				@if (showClearButton && !disabled) {
					<button
						type="button"
						class="btn btn-sm btn-link text-danger ms-1"
						(click)="clearFile()"
						[title]="'global.clear' | translate">
						<i class="fa fa-times"></i>
					</button>
				}
			} @else {
				{{ noFileLabel | translate }}
			}
		</span>
	</div>
</div>
